export default __webpack_public_path__ + "static/media/fresh_squeezed_lemonade_thumbnail.b2b50b22.JPG";